module.exports = __webpack_public_path__ + "static/repositorios.55e0139f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/git-github-presentation/repositorios.png
// module id = 1079
// module chunks = 32308089046778